<template>
  <div class="merchant-info-container">
    <div class="header">
      <div class="title">基本信息</div>
      <!-- <div class="select">
        <el-row :gutter="20">
          <el-col :span="2">
            <div class="label">选择门店</div>
          </el-col>
          <el-col :span="6">
            <el-select v-model="selectedMerchantId" placeholder="请选择">
              <el-option
                v-for="item in shopList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div> -->
    </div>
    <div class="content" v-loading="loading">
      <div class="info">
        <div class="item">
          <p class="title">基础信息</p>
          <ul class="row">
            <li class="label">总店商户名称</li>
            <li class="content">{{merchantInfoEntity.headMerchantName}}</li>
            <li class="label">门店名称</li>
            <li class="content">{{merchantInfoEntity.merchantName}}</li>
            <li class="label">商户编号</li>
            <li class="content">{{merchantInfoEntity.merchantId}}</li>

            <li class="label">门店编号</li>
            <li class="content">{{merchantInfoEntity.shopId}}</li>
            <li class="label">门店状态</li>
            <li class="content">{{merchantInfoEntity.shopStatusValue}}</li>
            <li class="label">门店类型</li>
            <li class="content">{{merchantInfoEntity.shopTypeValue}}</li>

            <li class="label">登录账号</li>
            <li class="content">{{merchantInfoEntity.userName}}</li>
          </ul>
        </div>
        <div class="item">
          <p class="title">门店信息</p>
          <ul class="row">
            <li class="label">法人名称</li>
            <li class="content">{{merchantInfoEntity.legalName}}</li>
            <li class="label">法人身份证</li>
            <li class="content">{{merchantInfoEntity.legalIdcard}}</li>
            <li class="label">联系电话</li>
            <li class="content">{{merchantInfoEntity.contactMobile}}</li>

            <li class="label">所属行业</li>
            <li class="content">{{merchantInfoEntity.mccValue}}</li>
            <li class="label">经营省市</li>
            <li class="content">{{merchantInfoEntity.province}}-{{merchantInfoEntity.city}}</li>
            <li class="label">实际经营地址</li>
            <li class="content">{{merchantInfoEntity.address}}</li>

            <li class="label">营业执照名称</li>
            <li class="content">{{merchantInfoEntity.licenseName}}</li>
             <li class="label">营业执照编号</li>
            <li class="content">{{merchantInfoEntity.license}}</li>
          </ul>
        </div>
        <div class="item" v-if="shopType==1">
          <p class="title">结算信息</p>
          <ul class="row">
            <li class="label">开户名称</li>
            <li class="content">{{merchantInfoEntity.bankHolder}}</li>
            <li class="label">账户类型</li>
            <li class="content">{{merchantInfoEntity.bankAccountTypeName}}</li>
            <li class="label">银行卡号</li>
            <li class="content">{{merchantInfoEntity.bankAccount}}</li>

            <li class="label">开户银行</li>
            <li class="content">{{merchantInfoEntity.bankName}}</li>
            <li class="label">银行网点</li>
            <li class="content">{{merchantInfoEntity.bankBranchName}}</li>
          </ul>
        </div>
      </div>
      <div class="fee">
        <div class="item">
          <p class="title">刷卡费率</p>
          <el-table
            :data="posRateArr"
            border
            style="width: 841px">
            <el-table-column
              prop="type"
              label="类型"
              width="120">
            </el-table-column>
            <el-table-column
              prop="rate"
              label="D+1费率"
              width="360">
            </el-table-column>
            <el-table-column
              prop="fee"
              label="D+1封顶手续费"
              width="360">
            </el-table-column>
          </el-table>
        </div>
        <div class="item">
          <p class="title">扫码费率</p>
          <el-table
            :data="scanRateArr"
            border
            style="width: 481px">
            <el-table-column
              prop="type"
              label="类型"
              width="120">
            </el-table-column>
            <el-table-column
              label="D+1费率"
              width="360">
              <template slot-scope="scope">
                {{scope.row.rate}}
                <el-tooltip v-if="scope.row.isShowDesc" :content="scope.row.desc" placement="top">
                  <i class="tips"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="item">
          <p class="title">银联二维码率</p>
          <el-table
            :data="codeRateArr"
            border
            style="width: 1201px">
            <el-table-column
              prop="type"
              label="类型"
              width="120">
            </el-table-column>
            <el-table-column
              prop="level1"
              label="D+1费率>1000元"
              width="360">
            </el-table-column>
            <el-table-column
              prop="fee"
              label="D+1封顶手续费"
              width="360">
            </el-table-column>
            <el-table-column
              prop="level2"
              label="D+1费率<=1000元"
              width="360">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryMerchantInfo, queryMerchantRate } from '@/api/merchant-info';

export default {
  data() {
    return {
      activeTab: 0,
      activeTimeType: 0,
      loading: false,
      merchantInfoEntity: {
        shopId: '', // 只需一个值更新，即可带动其他值更新
      },
      scanRateArr: [], // 微信支付宝费率
      posRateArr: [], // 刷卡费率
      codeRateArr: [], // 银联二维码
      shopList: [],
      shopType: 0,
      // selectedMerchantId: '',
    };
  },
  watch: {

  },
  methods: {
    selectedMerchantId() {
      this.selectedMerchantId = this.$route.query.merchantId;
      const params = { merchantId: this.selectedMerchantId };
      this.loading = true;
      Promise.all([queryMerchantInfo(params), queryMerchantRate(params)]).then((result) => {
        if (result[0].data.error_code === 0) {
          this.merchantInfoEntity = result[0].data.data;
        }

        if (result[1].data.error_code === 0) {
          this.scanRateArr = [
            {
              type: '微信',
              rate: `${(result[1].data.data.scanWeixin / 100).toFixed(2)}%`,
              isShowDesc: result[1].data.data.wxSubsidyFlag,
              desc: `商家手续费率为${(result[1].data.data.wxBaseRate / 100).toFixed(2)}%，奖励金费率为${(result[1].data.data.wxSubsidyRate / 100).toFixed(2)}%`,
            },
            {
              type: '支付宝',
              rate: `${(result[1].data.data.scanAlipay / 100).toFixed(2)}%`,
              isShowDesc: result[1].data.data.alipaySubsidyFlag,
              desc: `商家手续费率为${(result[1].data.data.alipayBaseRate / 100).toFixed(2)}%，奖励金费率为${(result[1].data.data.alipaySubsidyRate / 100).toFixed(2)}%`,
            },
          ];

          this.codeRateArr = [
            {
              type: '借记卡',
              level1: `${result[1].data.data.scanDebitUnionLevel / 100}%`,
              fee: result[1].data.data.scanDebitUnionMaxFee,
              level2: `${result[1].data.data.scanDebitUnionLevel2 / 100}%`,
            },
            {
              type: '贷记卡', // 没有手续费
              level1: `${result[1].data.data.scanCreditUnionLevel / 100}%`,
              fee: '--',
              level2: `${result[1].data.data.scanCreditUnionLevel2 / 100}%`,
            },
          ];

          this.posRateArr = [
            {
              type: '借记卡',
              rate: `${result[1].data.data.posDebit / 100}%`,
              fee: result[1].data.data.posDebitCardMaxFee,
            },
            {
              type: '贷记卡',
              rate: `${result[1].data.data.posCredit / 100}%`,
              fee: '--',
            },
            // {
            //   type: '境外卡',
            //   rate: `${result[1].data.data.posOversea / 100}%`,
            //   fee: '--',
            // },
          ];
        }

        this.loading = false;
      });
    },
  },
  created() {
    this.shopType = this.$route.query.shopType;
    this.selectedMerchantId();
  },
};
</script>
<style lang="scss">
.merchant-info-container {
  background-color: #F7F7F7;
  > .header {
    padding-left: 50px;
    background-color: #fff;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: '';
        display: block;
        height: 0px;
        border-bottom: 1px solid #F2F3F3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
    .select {
      padding: 30px 0;
      margin-bottom: 20px;
      .label {
        height: 38px;
        line-height: 38px;
      }
    }
  }
  > .content {
    .info {
      background-color: #fff;
      padding-left: 50px;
      padding-bottom: 60px;
      margin-bottom: 20px;
      .item {
        .title {
          color: #333333;
          padding: 30px 0 20px 0;
          font-size: 14px;
          margin: 0;
        }
        .row {
          width: 1260px;
          &:after {
            content: '';
            display: block;
            clear: both;
          }
          li {
            margin-right:-1px;
            margin-bottom: -1px;
            // display:table-cell;
            float: left;
          }
          .label {
            width: 120px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            background-color: #FAFAFA;
            color: #43476A;
            font-size: 14px;
            border: 1px solid #E8EEF3;
          }
          .content {
            width: 300px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            background-color: #fff;
            color: #43476A;
            font-size: 14px;
            border: 1px solid #E8EEF3;
          }
        }
      }
    }
    .fee {
      background-color: #fff;
      padding-left: 50px;
      margin-bottom: 20px;
      .item {
        padding-bottom: 60px;
        .title {
          color: #333333;
          padding: 30px 0 20px 0;
          font-size: 14px;
          margin: 0;
        }
        .has-gutter {
          tr {
            background-color: #FAFAFA;
          }
        }
        .cell {
          text-align: center;
          .tips {
            background: url("../../assets/images/report/questionh.png") no-repeat !important;
            background-size: 100%;
            width: 16px;
            height: 16px;
            display: inline-block;
            margin-left: 6px;
            vertical-align: middle;
            cursor: pointer;
            margin-top: 1.5px;
          }
        }
      }
    }
  }
}
</style>
